





























import { Component, Emit, Prop } from 'vue-property-decorator'

import {
  BotProperty, GroupedBotProperty,
} from '../../../../../../../../../../../BotProperties/components/Properties/types'
import { UseFields } from '../../../../../../../../../../../Pi'
import {
  PropertyValue,
  PropValueCalculate,
  PropValueConstant,
  PropValueProperty,
} from '../../../../../logic/Actions/PropertyAction/PropertyActionValue'
import { PropertyActionType, SetPropertyActionValue } from '../../../../../logic/Actions/PropertyAction/types'
import { ActionNodeProps } from '../../../../../logic/types'
import PropertyValueCalculate from './PropertyValueCalculate.vue'
import PropertyValueConstant from './PropertyValueConstant.vue'
import PropertyValueProperty from './PropertyValueProperty.vue'

@Component({
  data() {
    return {
      SetPropertyActionValue,
      PropValueProperty,
      PropValueCalculate,
      PropValueConstant,
    }
  },
  components: {
    PropertyValueProperty,
    PropertyValueCalculate,
    PropertyValueConstant,
  }
})
export default class PropertyActionValueSettings extends UseFields {
  @Prop() value!: PropertyValue

  @Prop() action!: PropertyActionType

  @Prop() getProperties!: () => Array<GroupedBotProperty>

  @Prop() currentProperty!: GroupedBotProperty | undefined

  @Prop() createNewProperty!: (path: string, name: string, parent?: number) => Promise<Array<BotProperty> | void>

  @Prop() compatibleProperties!: Array<GroupedBotProperty>

  @Prop() mediaTargetId!: ActionNodeProps['target']

  @Emit()
  setValuePropIndex(index: number): number {
    return index
  }

  @Emit()
  setValueInActionValue(value: string | number | boolean): string | number | boolean {
    return value
  }
}
